import { useState,useEffect } from "react";
import apiService from '../../../Services/apiService'; 
import {useLoading} from "../../../Context/LoadingContext";
type Props = { 
     _setbranchesData:(data: any) => void;
};
const Header =  ({_setbranchesData }: Props) =>{ 
     const {
    showLoader,
    hideLoader
  } = useLoading();
      const [branchesData, setbranchesData] = useState<any[]>([]);
      const [shops, setShops] = useState<any[]>([]);
      const [filterShops, setfilterShops] = useState<any[]>([]);
      const [areas, setAreas] = useState<any[]>([]);
      const [cities, setCities] = useState<any[]>([]);
      const [categories, setcategories] = useState<any[]>([]);
      const [selectedShops, setSelectedShops] = useState<Number[]>([]);
      const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
      const [selectedCities, setSelectedCities] = useState<string[]>([]);
      const [selectedCategories, setSelectedCategories] = useState<Number[]>([]);
      const [searchValue, setSearchValue] = useState("");
    useEffect(() => { 
     showLoader();
     fetshShops(0);
     fetshAreas(0);
     fetshCategories(0);
     hideLoader();
  }, []);
   const fetshShops =async (startIndex: number): Promise<void> => {
     try {
       debugger; 
       const result = await apiService.fetchGetData("api/GetShops", {}); 
         setShops(result.data); 
         setfilterShops(result.data);
     } catch (error) {
       console.error("Error fetching tags:", error);
       setShops([]); // Handle error case
     }
   };
      const fetshAreas =async (startIndex: number): Promise<void> => {
     try { 
       const result = await apiService.fetchGetData("api/GetCitiesAndAreas", {});  
         setAreas(result.areas); 
         setCities(result.cities); 
     } catch (error) {
       console.error("Error fetching tags:", error);
       setAreas([]); 
       setCities([]);
       // Handle error case
     }
   };
    const fetshCategories =async (startIndex: number): Promise<void> => {
     try {
       debugger; 
       const result = await apiService.fetchGetData("api/GetCategories", {}); 
         setcategories(result.data); 
     } catch (error) {
       console.error("Error fetching tags:", error);
       setcategories([]); // Handle error case
     }
   };
    const filterBranches =async (): Promise<void> => {
      showLoader();
        console.log(selectedCities);
     try {
     
       const result = await apiService.fetchData("api/FilterBranches", {
        ShopIds:selectedShops,
        Regions:selectedAreas,
        Cities:selectedCities,
        ServiceIds:selectedCategories,
        PageNumber:1,
        PageSize:0
       }); 
        
         setbranchesData(result.data); 
         _setbranchesData(result.data); 
          hideLoader();
     } catch (error) {
       console.error("Error fetching tags:", error);
       setShops([]); // Handle error case
     }
   };
   const handleCitySearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase(); 
    if(search!=="")
    {
  const result = cities.filter((city) =>
      city.toLowerCase().includes(search)
    );

    setCities(result);
    }
    else
      fetshAreas(0);
  
  //}
};
  const handleAreaSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase(); 
    if(search!=="")
    {
  const result = areas.filter((area) =>
      area.toLowerCase().includes(search)
    );

    setAreas(result);
    }
    else
      fetshAreas(0);
  
  //}
};
  const handleٍShopsSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase(); 
    if(search!=="")
    {
  const result = filterShops.filter((shop) =>
      shop.portName.toLowerCase().includes(search)
    );

    setShops(result);
    }
    else
      setShops(filterShops);
  
  //}
};
 
return <>
 
 <div
        className="absolute top-4 left-4 right-4 md:top-8 md:left-8 md:right-8 z-20 pointer-events-none transition-all duration-300"
        id="main-filter-bar"
      >
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pointer-events-auto">
          {/* Brand / Context (Optional) */}
          <div className="hidden md:flex items-center gap-3 bg-surface/95 backdrop-blur-xl px-6 py-3 rounded-xl shadow-lg border-b border-primary/10">
            <img
              alt="Horizon Prime Logo"
              className="h-8 w-auto object-contain"
              src="	https://c.manafithsys.com/images/logo.png"
            />
            <h2 className="font-headline-md text-headline-md text-on-surface m-0">
              تصفح فروع المتاجر
            </h2>
          </div>
          {/* Filters */}
          <div className="flex-1 w-full md:w-auto bg-surface/95 backdrop-blur-xl rounded-xl shadow-xl p-2 md:p-3 flex flex-wrap md:flex-nowrap items-center gap-2 border-b border-primary/10">
            <div className="flex-1 min-w-[120px] relative group">
              <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">
                    storefront
                  </span>
                 <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                    {selectedShops.length}
                  </span>
                  كل المتاجر
                </span>
                <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                  expand_more
                </span>
              </button>
              <div className="absolute top-full right-0 pt-2 w-64 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-2 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                  <div className="relative">
                      <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                        search
                      </span>
                      <input
                        className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                        placeholder="بحث عن المتجر..."
                        type="text"
                          value={searchValue}
  onChange={(e) =>{setSearchValue(e.target.value);}}
  onKeyDown={handleٍShopsSearch}
                      />
                    </div>
                  <div className="flex flex-col gap-1">
                     {shops.map((item) => (
       <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors">
                      <input id={item.shopId}
                        className="w-4 h-4 rounded border-outline accent-primary"
                        type="checkbox"
                          checked={selectedShops.includes(item.shopId)}
      onChange={(e) => {
        if (e.target.checked) {
          // Add shopId
          setSelectedShops((prev) => [
            ...prev,
            item.shopId,
          ]);
        } else {
          // Remove shopId
          setSelectedShops((prev) =>
            prev.filter((id) => id !== item.shopId)
          );
        }
      }}
                      /> 
                      <span className="text-label-md">  {item.portName}</span>
                    </label>
 ))} 
                  </div>
                </div>
              </div>
            </div>
            <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
            <div className="flex-1 min-w-[160px] relative group">
              <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">
                    location_city
                  </span>
                  <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                    {selectedCities.length}
                  </span>
                  المدن المختارة
                </span>
                <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                  expand_more
                </span>
              </button>
              <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                  <div className="flex flex-col gap-3">
                    <div className="relative">
                      <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                        search
                      </span>
                      <input
                        className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                        placeholder="بحث عن مدينة..."
                        type="text"
                          value={searchValue}
  onChange={(e) =>{setSearchValue(e.target.value);}}
  onKeyDown={handleCitySearch}
                      />
                    </div>
                    <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                   
                 {cities.map((item) => (
  <label
    key={item}
    className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item"
  >
    <input
      className="w-4 h-4 rounded border-outline accent-primary"
      type="checkbox"
      checked={selectedCities.includes(item)}
      onChange={(e) => {
        if (e.target.checked) {
          // Add city
          setSelectedCities((prev) => [
            ...prev,
            item,
          ]);
        } else {
          // Remove city
          setSelectedCities((prev) =>
            prev.filter((city) => city !== item)
          );
        }
      }}
    />

    <span className="text-label-md group-hover/item:text-primary transition-colors">
      {item}
    </span>
  </label>
))}
                    </div>
                    {/* <div className="flex items-center justify-between pt-2 border-t border-outline-variant/20">
                      <button className="text-label-sm text-outline hover:text-error transition-colors">
                        مسح الكل
                      </button>
                      <button className="bg-primary text-on-primary px-4 py-1.5 rounded-lg text-label-sm hover:bg-primary/90 transition-colors">
                        تطبيق
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
            <div className="flex-1 min-w-[160px] relative group">
              <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">
                    map
                  </span>
                <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                    {selectedAreas.length}
                  </span>
                  كل المناطق
                </span>
                <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                  expand_more
                </span>
              </button>
              <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                  <div className="flex flex-col gap-3">
                    <div className="relative">
                      <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                        search
                      </span>
                      <input
                        className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                        placeholder="بحث عن منطقة..."
                        type="text"
                          value={searchValue}
  onChange={(e) =>{setSearchValue(e.target.value);}}
  onKeyDown={handleAreaSearch}
                      />
                    </div>
                    <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                    
                                {areas.map((item) => (
       <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item">
                        <input
                          className="w-4 h-4 rounded border-outline accent-primary"
                          type="checkbox"
                           checked={selectedAreas.includes(item)}
      onChange={(e) => {
        if (e.target.checked) {
          // Add area
          setSelectedAreas((prev) => [
            ...prev,
            item,
          ]);
        } else {
          // Remove area
          setSelectedAreas((prev) =>
            prev.filter((area) => area !== item)
          );
        }
      }}
                        />
                        <span className="text-label-md group-hover/item:text-primary transition-colors">
                           {item}
                        </span>
                      </label>
 ))} 
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
            <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
            <div className="flex-1 min-w-[160px] relative group">
              <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">
                    mobile_arrow_right
                  </span>
                  <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                    {selectedCategories.length}
                  </span>
                  كل الخدمات
                </span>
                <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                  expand_more
                </span>
              </button>
              <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                     
                                    {categories.map((item) => (
    <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item">
                        <input id={item.catId}
                          className="w-4 h-4 rounded border-outline accent-primary"
                          type="checkbox"
                                 checked={selectedCategories.includes(item.catId)}
      onChange={(e) => {
        if (e.target.checked) {
          // Add category
          setSelectedCategories((prev) => [
            ...prev,
            item.catId,
          ]);
        } else {
          // Remove category
          setSelectedCategories((prev) =>
            prev.filter((id) => id !== item.catId)
          );
        }
      }}
                        />
                        <span className="text-label-md group-hover/item:text-primary transition-colors">
                          {item.name}
                        </span>
                      </label>
 ))} 
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            <button type="button" onClick={filterBranches} className="w-full md:w-auto bg-primary text-on-primary font-label-md text-label-md px-6 py-3 rounded-lg shadow-md hover:bg-primary/90 hover:shadow-lg transition-all flex items-center justify-center gap-2 mt-2 md:mt-0">
              <span className="material-symbols-outlined text-[18px]">
                travel_explore
              </span>
              بحث
            </button>
          </div>
        </div>
      </div>
</>

}
export default Header;